import React, { useState, useEffect, useContext } from 'react';
import { ThemeProvider, createTheme } from '@mui/material';
import MaterialTable from 'material-table';
import "./governMeetings.css";
import { Url } from '../../../../constants/ApiUrlConstants';
import { GET, PUT, DELETE } from '../../../Common/HttpMethods/HttpMethods';
import { contextData } from '../../../../context/ContextProvider';
import { BsEye, BsDownload } from "react-icons/bs";
import { SlPencil } from "react-icons/sl";
import { FaCheckCircle } from "react-icons/fa";
import { IoIosShareAlt } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import SuccessModal from '../../../Common/Popups/SuccessModal';
import FailModal from '../../../Common/Popups/FailModal';
import {
  Cuurent_EMAIL,
  Cuurent_RBAC_roles,
  getAllToFromOptionalEmailArr,
  getColumns
} from '../../../CommonCase/CommonFunctions';


// export const getMeetingData = (
//   selectedFromDate,
//   selectedToDate,
//   Url,
//   fetchData,
//   setData,
//   setDataCopy,
//   setOpenFailModal
// ) => {
//   const fromDate = moment(selectedFromDate).format('YYYY-MM-DD');
//   const toDate = moment(selectedToDate).format('YYYY-MM-DD');
//   const url = Url.getMeetingsByTagAndRec
//     .replace("{startDate}", fromDate)
//     .replace("{endDate}", toDate)
//     .replace("{deptTagId}", "2");

//   fetchData(
//     url,
//     (response) => {
//       const indexedData = response.DATA.scheduleMeeting.map((i, ind) => ({
//         ...i,
//         index: ind + 1
//       }));
//       setData(indexedData);
//       setDataCopy(indexedData);
//     },
//     () => setOpenFailModal(true),
//     "Failed to fetch meetings."
//   );
// };

export const getMeetingData = async ({
  selectedFromDate,
  selectedToDate,
  setLoading,
  setData,
  setDataCopy,
  setSessionExpiredModal,
  setFailMessage,
  setOpenFailModal,
  token,
}) => {
  try {
    setLoading(true);
    let fromDate = moment(selectedFromDate).format('YYYY-MM-DD');
    let toDate = moment(selectedToDate).format('YYYY-MM-DD');

    const meetingResponse = await GET(
      Url.getMeetingsByTagAndRec
        .replace("{startDate}", `${fromDate}`)
        .replace("{endDate}", `${toDate}`)
        .replace("{deptTagId}", "2"),
      token
    );

    if (meetingResponse?.SUCCESS) {
      const IndexedData = meetingResponse?.DATA?.scheduleMeeting.map((i, ind) => {
        return { ...i, index: ind + 1 };
      });

      setData(IndexedData);
      setDataCopy(IndexedData);
      setLoading(false);
    } else if (meetingResponse.STATUS === 401) {
      setLoading(false);
      setSessionExpiredModal(true);
      setFailMessage("Session expired");
    }else {
      setLoading(false);
      setFailMessage("Failed to fetch meetings.");
      setOpenFailModal(true);
    }
  } catch (error) {
    setLoading(false);
    setFailMessage("Failed to fetch meetings.");
    setOpenFailModal(true);
  }
};

export const closeModal = (setModalFunc) => {setModalFunc(false)};

export const handleSearch = (inp, dataCopy, setData) => {
  setData(
    dataCopy.filter((i) =>
      i.meetingSubject.toLowerCase().includes(inp.toLowerCase())
    )
  );
};


// export const handleDeleteMeeting = async (
//   meetingIdToDelete,
//   Url,
//   fetchData,
//   getMeetingData,
//   selectedFromDate,
//   selectedToDate,
//   setData,
//   setDataCopy,
//   setOpenWarningModal,
//   setSuccessMessage,
//   setOpenSuccessModal,
//   setOpenFailModal
// ) => {
//   setOpenWarningModal(false);

//   const url = Url.deleteMeeting.replace("{mid}", meetingIdToDelete);

//   fetchData(
//     url,
//     () => {
//       getMeetingData(
//         selectedFromDate,
//   selectedToDate,
//   setLoading,
//   setData,
//   setDataCopy,
//   setSessionExpiredModal,
//   setFailMessage,
//   setOpenFailModal,
//   token,
//       );

//       setSuccessMessage("Meeting deleted successfully.");
//       setOpenSuccessModal(true);
//     },
//     () => setOpenFailModal(true),
//     "Failed to delete meeting."
//   );
// };


// export const handleDeleteMeeting = async ({
//   meetingIdToDelete,
//   setLoading,
//   setOpenWarningModal,
//   DELETE,
//   Url,
//   token,
//   getMeetingData,
//   selectedFromDate,
//   selectedToDate,
//   setData,
//   setDataCopy,
//   setSessionExpiredModal,
//   setFailMessage,
//   setOpenFailModal,
//   setSuccessMessage,
//   setOpenSuccessModal,
// }) => {
//   setOpenWarningModal(false);
//   try {
//     setLoading(true);
//     const deleteMeetingResp = await DELETE(Url.deleteMeeting.replace("{mid}", `${meetingIdToDelete}`), token);

//     if (deleteMeetingResp.SUCCESS) {
//       getMeetingData({
//         selectedFromDate,
//         selectedToDate,
//         setLoading,
//         setData,
//         setDataCopy,
//         setSessionExpiredModal,
//         setFailMessage,
//         setOpenFailModal,
//         token,
//       });
//       setLoading(false);
//       setSuccessMessage("Meeting deleted Successfully.");
//       setOpenSuccessModal(true);
//     } else if (deleteMeetingResp.STATUS === 401) {
//       setSessionExpiredModal(true);
//       setFailMessage("Session expired");
//     }else if (deleteMeetingResp.STATUS === 400) {
//       setSessionExpiredModal(true);
//       setFailMessage("Session expired");
//     }else if (deleteMeetingResp.STATUS === 403) {
//       setSessionExpiredModal(true);
//       setFailMessage("Session expired");
//     }else if (deleteMeetingResp.STATUS === 404) {
//       setSessionExpiredModal(true);
//       setFailMessage("Session expired");
//     }else if (deleteMeetingResp.STATUS === 500) {
//       setSessionExpiredModal(true);
//       setFailMessage("Session expired");
//     } else {
//       setLoading(false);
//       setFailMessage("Failed to delete meeting.");
//       setOpenFailModal(true);
//     }
//   } catch (error) {
//     setLoading(false);
//     setFailMessage("Failed to delete meeting.");
//     setOpenFailModal(true);
//   }
// };


export const handleEditAccess = (props, usermail, getAllToFromOptionalEmailArr, handleEditPast) => {
  const { allEmailIdArr } = getAllToFromOptionalEmailArr(props.participantsList);
  if (allEmailIdArr.includes(usermail)) {
    handleEditPast(props.mid);
  }
};

export const handleEditPast = (id, navigate) => {
  navigate("/main/meetings/edit-past-meeting", { state: { meetingId: id } });
};


const GovernanceMeetings = ({ selectedToDate, selectedFromDate, tableIcons, searchInp, selectedPeriod }) => {

  const [data, setData] = useState([]);
  const [dataCopy, setDataCopy] = useState([]);
  const [meetingIdToDelete, setMeetingIdToDelete] = useState(null);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [openFailModal, setOpenFailModal] = useState(false);
  const [failMessage, setFailMessage] = useState("");
  const [openWarningModal, setOpenWarningModal] = useState(false);
  const [sessionExpiredModal, setSessionExpiredModal] = useState(false);

  const theme = createTheme();
  const navigate = useNavigate();
  const { setViewPastMeeting, setLoading, setActive } = useContext(contextData);

  const token = sessionStorage.getItem('TOKEN');
  const usermail = Cuurent_EMAIL();
  const storedRbacRoles = JSON.parse(Cuurent_RBAC_roles());
  const [rbac, setRbac] = useState({});

  useEffect(() => {
    const userRole = sessionStorage.getItem("USER");
    if (userRole !== "USER") {
      const roleWithQMSDashboard = storedRbacRoles?.find(role => role.useCase === "QMS Meetings Summary");
      if (roleWithQMSDashboard) {
        setRbac(roleWithQMSDashboard);
      }
    }
  }, []);

  




  // const handleDeletePermission = (id) => {
  //   setMeetingIdToDelete(id);
  //   setOpenWarningModal(true);
  //   setFailMessage("Are you sure you want to delete meeting?");
  // };

  // const handleEditAccess = (props) => {
  //   const { allEmailIdArr } = getAllToFromOptionalEmailArr(props.participantsList);
  //   if (allEmailIdArr.includes(usermail)) {
  //     handleEditPast(props.mid);
  //   }
  // };

  // const handleEditPast = (id) => {
  //   navigate("/main/meetings/edit-past-meeting", { state: { meetingId: id } });
  // };

  //const closeModal = (setModalFunc) => setModalFunc(false);

  useEffect(() => {
    getMeetingData({
      selectedFromDate,
      selectedToDate,
      setLoading,
      setData,
      setDataCopy,
      setSessionExpiredModal,
      setFailMessage,
      setOpenFailModal,
      token,
    });
  }, [selectedToDate, selectedFromDate]);

  useEffect(() => {
    handleSearch(searchInp, dataCopy, setData);
  }, [searchInp, dataCopy, setData]);

  useEffect(() => {
      const text = document.getElementsByClassName("MuiTablePagination-selectLabel");
      [...text][0].innerHTML = "Show Entries";
      [...text][0].style.fontSize = "13px"
    }, [])

  const columns = getColumns(
    { borderRight: "1px solid #b8b8b8", padding: "0px 6px",whiteSpace: "nowrap" },
    { borderRight: '1px solid gray' },
    { borderRight: '1px solid gray', color: "black" },
    usermail,
    rbac,
    setViewPastMeeting,
    (props) => handleEditAccess(
      props,
      usermail,
      getAllToFromOptionalEmailArr,
      (id) => handleEditPast(id, navigate)
    ),
    "#057DAA",
    "Go",
    navigate
  );

  return (
    <div className="governance-table-container" style={{ marginTop: "10px" }}>
      <ThemeProvider theme={theme}>
        <MaterialTable
          data={data}
          localization={{
            body: { emptyDataSourceMessage: <span className="no_data_found_table">No Records to show</span> }
          }}
          columns={columns}
          icons={tableIcons}
          options={{
            toolbar: false,
            search: false,
            draggable: false,
            pageSizeOptions: [5, 10, 15, 20],
            pageSize: 10,
            headerStyle: {
              backgroundColor: '#D9EDF6',
              color: "#057DAA",
              fontWeight: "bold",
              position: 'sticky',
              top: -1
            },
            maxBodyHeight: '57vh',
            minBodyHeight: '57vh'
          }}
        />
      </ThemeProvider>
      <SuccessModal
        openSuccessModal={openSuccessModal}
        setOpenSuccessModal={setOpenSuccessModal}
        successMessage={successMessage}
        recallFunctionOnOk={() => closeModal(setOpenSuccessModal)}
      />
      <FailModal
        openFailModal={openFailModal}
        setOpenFailModal={setOpenFailModal}
        failMessage={failMessage}
        recallFunctionOnOk={() => closeModal(setOpenFailModal)}
      />
      {/* <FailModal
        openFailModal={openWarningModal}
        setOpenFailModal={setOpenWarningModal}
        failMessage={failMessage}
        recallFunctionOnOk={() =>
          handleDeleteMeeting(
            meetingIdToDelete,
  setLoading,
  setOpenWarningModal,
  DELETE,
  Url,
  token,
  getMeetingData,
  selectedFromDate,
  selectedToDate,
  setData,
  setDataCopy,
  setSessionExpiredModal,
  setFailMessage,
  setOpenFailModal,
  setSuccessMessage,
  setOpenSuccessModal,
          )
        }
      /> */}

      <FailModal
        openFailModal={sessionExpiredModal}
        setOpenFailModal={setSessionExpiredModal}
        failMessage={failMessage}
        recallFunctionOnOk={() => {
          sessionStorage.clear();
          navigate('/login');
          setActive('tab1');
        }}
      />
    </div>
  );
};

export default GovernanceMeetings;
